
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AdminGuard from '../components/AdminGuard';

// Lazy loading dos componentes
const Home = lazy(() => import('../pages/home/page'));
const Login = lazy(() => import('../pages/login/page'));
const Cadastro = lazy(() => import('../pages/cadastro/page'));
const Socio = lazy(() => import('../pages/socio/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const EstacionamentoPage = lazy(() => import('../pages/admin/EstacionamentoPage'));
const ConfiguracaoApiPage = lazy(() => import('../pages/admin/ConfiguracaoApiPage'));
const QuadrasPage = lazy(() => import('../pages/admin/QuadrasPage'));
const QuadrasV2Page = lazy(() => import('../pages/admin/QuadrasV2Page'));
const QuadrasConfigurarPage = lazy(() => import('../pages/admin/QuadrasConfigurarPage'));
const QuadrasCalendarioPage = lazy(() => import('../pages/admin/QuadrasCalendarioPage'));
const QuadrasPublicPage = lazy(() => import('../pages/quadras/page'));
const Password = lazy(() => import('../pages/password/page'));
const ResetarSenha = lazy(() => import('../pages/resetar-senha/page'));
const PagamentoSucesso = lazy(() => import('../pages/pagamento/sucesso/page'));
const ComprovantePage = lazy(() => import('../pages/comprovante/page'));
const LojaHomePage = lazy(() => import('../pages/loja/LojaHomePage'));
const CarrinhoPage = lazy(() => import('../pages/loja/CarrinhoPage'));
const CheckoutPage = lazy(() => import('../pages/loja/CheckoutPage'));
const LojaAdminPage = lazy(() => import('../pages/admin/LojaAdminPage'));
const LojaPedidosPage = lazy(() => import('../pages/admin/LojaPedidosPage'));
const LojaDashboardPage = lazy(() => import('../pages/admin/LojaDashboardPage'));
const LojaPDVPage = lazy(() => import('../pages/admin/LojaPDVPage'));
const FinanceiroPage = lazy(() => import('../pages/admin/FinanceiroPage'));
const RelatorioInadimplenciaPage = lazy(() => import('../pages/admin/RelatorioInadimplenciaPage'));
const RelatorioTotemPage = lazy(() => import('../pages/admin/RelatorioTotemPage'));
const CategoriaBasePage = lazy(() => import('../pages/admin/CategoriaBasePage'));
const ConfigRecibosPage = lazy(() => import('../pages/admin/ConfigRecibosPage'));
const DocumentosPage = lazy(() => import('../pages/admin/DocumentosPage'));
const FotosAdminPage = lazy(() => import('../pages/admin/FotosAdminPage'));
const CategoriaBasePublicPage = lazy(() => import('../pages/categoria-base/page'));
const CategoriaBaseCadastroPage = lazy(() => import('../pages/categoria-base/cadastro/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
// VAR desativado temporariamente (VarPage / VarPublicaPage)
const DefinirSenha = lazy(() => import('../pages/definir-senha/page'));
const QuadraClientePage = lazy(() => import('../pages/quadra-cliente/page'));
const TotemPage = lazy(() => import('../pages/totem/page'));
const AreaResponsavelPage = lazy(() => import('../pages/area-responsavel/page'));
const IngressosPage = lazy(() => import('../pages/ingressos/page'));
const IngressosConfirmacaoPage = lazy(() => import('../pages/ingressos/confirmacao'));
const IngressosAdminPage = lazy(() => import('../pages/admin/IngressosPage'));
const ScannerPage = lazy(() => import('../pages/admin/ScannerPage'));
const HostingerPage = lazy(() => import('../pages/admin/HostingerPage'));
const AstPage = lazy(() => import('../pages/admin/AstPage'));
import EstacionamentoPublicoPage from '../pages/estacionamento-publico/page';
import Estacionamento2Page from '../pages/estacionamento2/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/cadastro',
    element: <Cadastro />
  },
  {
    path: '/socio',
    element: <Socio />
  },
  {
    path: '/admin',
    element: <Admin />
  },
  {
    path: '/admin/estacionamento',
    element: <EstacionamentoPage />
  },
  {
    path: '/admin/configuracoes/estacionamento-api',
    element: <ConfiguracaoApiPage />
  },
  {
    path: '/admin/quadras',
    element: <QuadrasV2Page />
  },
  {
    path: '/admin/quadrasv2',
    element: <QuadrasPage />
  },
  {
    path: '/admin/quadras/configurar',
    element: <QuadrasConfigurarPage />
  },
  {
    path: '/admin/quadras/calendario',
    element: <QuadrasCalendarioPage />
  },
  {
    path: '/quadras',
    element: <QuadrasPublicPage />
  },
  {
    path: '/password',
    element: <Password />
  },
  {
    path: '/resetar-senha',
    element: <ResetarSenha />
  },
  {
    path: '/pagamento/sucesso',
    element: <PagamentoSucesso />
  },
  {
    path: '/comprovante',
    element: <ComprovantePage />
  },
  {
    path: '/comprovante/:id',
    element: <ComprovantePage />
  },
  {
    path: '/loja',
    element: <LojaHomePage />
  },
  {
    path: '/loja/carrinho',
    element: <CarrinhoPage />
  },
  {
    path: '/loja/checkout',
    element: <CheckoutPage />
  },
  {
    path: '/admin/loja',
    element: <LojaAdminPage />
  },
  {
    path: '/admin/loja/pedidos',
    element: <LojaPedidosPage />
  },
  {
    path: '/admin/loja/dashboard',
    element: <LojaDashboardPage />
  },
  {
    path: '/admin/loja/pdv',
    element: <LojaPDVPage />
  },
  {
    path: '/admin/financeiro',
    element: <FinanceiroPage />
  },
  {
    path: '/admin/relatorio-inadimplencia',
    element: <RelatorioInadimplenciaPage />
  },
  {
    path: '/admin/relatorio-totem',
    element: <RelatorioTotemPage />
  },
  {
    path: '/admin/categoria-base',
    element: <CategoriaBasePage />
  },
  {
    path: '/admin/config-recibos',
    element: <ConfigRecibosPage />
  },
  {
    path: '/admin/documentos',
    element: <DocumentosPage />
  },
  {
    path: '/admin/fotos',
    element: <FotosAdminPage />
  },
  {
    path: '/admin/ast',
    element: <AstPage />
  },
  {
    path: '/categoria-base',
    element: <CategoriaBasePublicPage />
  },
  {
    path: '/categoria-base/cadastro',
    element: <CategoriaBaseCadastroPage />
  },
  {
    // VAR desativado temporariamente — redireciona para a home
    path: '/var-publica',
    element: <Navigate to="/" replace />
  },
  {
    // VAR desativado temporariamente — redireciona para a home
    path: '/var',
    element: <Navigate to="/" replace />
  },
  {
    path: '/definir-senha',
    element: <DefinirSenha />
  },
  {
    path: '/quadra-cliente',
    element: <QuadraClientePage />
  },
  {
    path: '/totem',
    element: <TotemPage />
  },
  {
    path: '/area-responsavel',
    element: <AreaResponsavelPage />
  },
  {
    path: '/ingressos',
    element: <IngressosPage />
  },
  {
    path: '/ingressos/confirmacao',
    element: <IngressosConfirmacaoPage />
  },
  {
    path: '/admin/ingressos',
    element: <IngressosAdminPage />
  },
  {
    path: '/admin/scanner',
    element: <ScannerPage />
  },
  {
    path: '/admin/servidor',
    element: <HostingerPage />
  },
  {
    path: '*',
    element: <NotFound />
  },
  {
    path: '/estacionamento',
    element: <EstacionamentoPublicoPage />
  },
  {
    path: '/estacionamento2',
    element: <Estacionamento2Page />
  }
];

// Guard central: toda rota /admin/* (exceto o /admin de login) exige admin logado.
// Fecha de uma vez o acesso não autenticado às páginas administrativas.
const guardedRoutes: RouteObject[] = routes.map((r) =>
  typeof r.path === 'string' && r.path.startsWith('/admin/')
    ? { ...r, element: <AdminGuard>{r.element}</AdminGuard> }
    : r
);

export default guardedRoutes;
